import React, { useState } from "react";
import "./codeBox.css";
import { MdOutlineContentCopy } from "react-icons/md";

export default function CodeBox({label, code }) {
    const [copySuccess, setCopySuccess] = useState("");

    const copyToClipboard = () => {
        navigator.clipboard.writeText(code)
            .then(() => {
                setCopySuccess("Code copied to clipboard!");
                setTimeout(() => setCopySuccess(""), 2000);
            })
            .catch(() => {
                setCopySuccess("Failed to copy code.");
            });
    };

    return (
        <div className="code_box_int_0">
            <span className="code_box_int_label">
                {label}
            </span>

            <div className="code_box_int">
                <div className="code_box_header">
                    <div></div>
                    <button onClick={copyToClipboard} className="key_value_box_button">
                        <MdOutlineContentCopy className="copy_icon" />
                    </button>
                </div>
                <div className="code_box_int_value_with_buttons">
                    <pre className="code_box_int_value">
                        <code>{code}</code>
                    </pre>
                </div>
                {/* {copySuccess && <div className="copy_success_message">{copySuccess}</div>} */}
            </div>
        </div>
    );
}